import { DataAutomation } from "../../components/CollapsibleTable";

export interface ICapabiltity {
  description: string;
  droppedDate: string;
  effectiveDate: string;
}

export interface ICapabilityItem {
  description: string;
  capabilities: ICapabiltity[];
}

export interface ICapabilitiesData {
  currentCapabilitiesCount: number;
  droppedCapabilitiesCount: number;
  currentCapabilities: ICapabilityItem[] | null;
  droppedCapabilities: ICapabilityItem[] | null;
}

export const CurrentCapabilitiesDataAutomation: DataAutomation = {
  tBody: 'current-capabilities-table',
  noRecords: 'current-capabilities-no-records',
  columns: [],
}

export const DroppedCapabilitiesDataAutomation: DataAutomation = {
  tBody: 'dropped-capabilities-table',
  noRecords: 'dropped-capabilities-no-records',
  columns: []
}